export default "__VITE_ASSET__P5P9OL2V__"